"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalIntersection = optionalIntersection;
const intersection_1 = __importDefault(require("lodash/intersection"));
function optionalIntersection(mainArr, restrictedArr) {
    if (mainArr && restrictedArr) {
        return (0, intersection_1.default)(mainArr, restrictedArr);
    }
    return mainArr ?? restrictedArr;
}
//# sourceMappingURL=optional-intersection.js.map